import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import LearningCollectionEditStore from '../../Store';
import { Sharing } from '../../Store/Types';
import Navigation from '../Navigation';
import NavButtons from './NavButtons';
import PublishSection from './PublishSection';
import ShareSection from './ShareSection';

interface Props {
  store: LearningCollectionEditStore;
  state: Sharing;
}

function Share({ store, state }: Props) {
  return (
    <div className="relative h-[85vh] overflow-auto">
      <Navigation store={store}>
        <NavButtons store={store} state={state} />
      </Navigation>
      <div className="px-2.5 pb-4 pt-20 md:flex-row lg:px-12">
        <h1 className="my-8 text-center text-2xl font-semibold">
          <T kind="Share Your Learning Collection" />
        </h1>
        <div className="flex flex-col place-content-center md:flex-row">
          <ShareSection template={store.template} />
          <div className="flex flex-col justify-center px-10">
            <div className="pb-1 text-center text-8xl font-thin text-gray-200">|</div>
            <div className="pb-3 text-6xl text-gray-600">+</div>
            <div className="text-center text-8xl font-thin text-gray-200">|</div>
          </div>
          <PublishSection publishingStore={store.publishingStore} />
        </div>
      </div>
    </div>
  );
}

export default observer(Share);
